import { LocaleUtil } from "./LocaleUtil";
import { DateFormatMap, DefaultDateFormatMap, DefaultDateTimeFormatMap } from "../griddle/models/Locale";
var DateUtil = /** @class */ (function () {
    function DateUtil() {
    }
    /**
     * Returns formatted date as string using the cell's DateFormat
     * @param {string} date date in ISO format
     * @param {Locale} locale user's locale code
     * @param {DateFormat} dateFormat current date format options
     */
    DateUtil.getLocalizedDateStringFromCellDateFormat = function (date, locale, dateFormat) {
        var dateFormatString = DateFormatMap.get(dateFormat);
        // locale based DateFormat will be undefined
        if (!dateFormatString) {
            return DateUtil.getDefaultLocalizedDateString(date, locale);
        }
        return DateUtil.getLocalizedDateString(date, locale, dateFormatString);
    };
    /**
     * Returns default formatted date as string
     * @param {string} date date in ISO format
     * @param {Locale} locale user's locale code
     */
    DateUtil.getDefaultLocalizedDateString = function (date, locale) {
        var dateFormatString = DefaultDateFormatMap.get(locale);
        // use en-US default format if not found
        if (!dateFormatString) {
            var enUSDateFormat = DefaultDateFormatMap.get("en-US");
            dateFormatString = enUSDateFormat ? enUSDateFormat : "";
        }
        return DateUtil.getLocalizedDateString(date, locale, dateFormatString);
    };
    /**
     * Returns formatted date as string using the locale's DateFormatString
     * or a desired token pattern as a string, i.e., default formats.
     * @param {string} date date in ISO format
     * @param {Locale} locale user's locale code
     * @param {string} dateFormatString used to determine the date pattern, should
     * follow the DateFormatString type. Parameter type is string since that type
     * is returned from the DefaultDateFormatMap.
     */
    DateUtil.getLocalizedDateString = function (date, locale, dateFormatString) {
        return LocaleUtil.getDateString(date, locale, dateFormatString);
    };
    /**
     * Returns default formatted date and time as string
     * @param {string} date date in ISO format
     * @param {Locale} locale user's locale code
     * @param {string} timezone user's timezone
     */
    DateUtil.getDefaultLocalizedDateTimeString = function (date, locale, timezone) {
        var dateFormatString = DefaultDateTimeFormatMap.get(String(locale));
        // use en-US default format if not found
        if (!dateFormatString) {
            var enUSDateFormat = DefaultDateTimeFormatMap.get("en-US");
            dateFormatString = enUSDateFormat ? enUSDateFormat : "";
        }
        return DateUtil.getLocalizedDateTimeString(date, locale, dateFormatString, timezone);
    };
    /**
     * Returns formatted date and time as string using the locale's DateFormatString
     * or a desired token pattern as a string, i.e., default formats.
     * @param {string} date date in ISO format
     * @param {Locale} locale user's locale code
     * @param {string} dateFormatString used to determine the date pattern, should
     * follow the DateFormatString type. Parameter type is string since that type
     * is returned from the DefaultDateTimeFormatMap.
     * @param {string} timezone user's timezone
     */
    DateUtil.getLocalizedDateTimeString = function (date, locale, dateFormatString, timezone) {
        return LocaleUtil.getDateTimeString(date, String(locale), dateFormatString, timezone);
    };
    return DateUtil;
}());
export { DateUtil };
//# sourceMappingURL=DateUtil.js.map